import ContainerDetail from '../organisms/ContainerDetail';
import CircularProgress from '@mui/material/CircularProgress';
import { withStyles } from 'tss-react/mui';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import queryString from 'query-string';
import { loadContainer, loadEventHistory } from '../../store/actions/containerActions';
import { errorMessage, successMessage } from '../../store/actions/messageActions';
import { getSelectedContainer } from '../../store/selectors/selectors';
import LoaderTimeout from '../organisms/LoaderTimeout';

const styles = (theme) => ({
  circularProgress: {
    marginLeft: '50%',
    marginTop: '5%',
  },
  breadBar: {
    marginBottom: theme.spacing(2),
  },
});

function SubscriptionDetail(props) {
  const { loadContainer, loadEventHistory, container, selectedUserType, classes } = props;
  const [containerLoaded, setContainerLoaded] = React.useState(false);
  const [queryParams, setQueryParams] = React.useState(null);

  useEffect(() => {
    if (!containerLoaded) {
      const query = queryString.parse(props.location.search);
      loadContainer(query);
      setQueryParams(query);
    }
    setContainerLoaded(true);
  });

  const loadEventsAction = () => {
    if (queryParams != null) {
      loadEventHistory(queryParams);
    }
  };

  return (
    <React.Fragment>
      {container.loading && <CircularProgress className={classes.circularProgress} />}
      {!container.loading && containerLoaded && (
        <ContainerDetail
          container={container}
          selectedUserType={selectedUserType}
          loadEventsAction={loadEventsAction}
        />
      )}
      <LoaderTimeout loading={container.loading} />
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    container: getSelectedContainer(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loadContainer,
      loadEventHistory,
      errorMessage,
      successMessage,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SubscriptionDetail, styles));
